import "./smooth-scrollbar.scss";

import { isMobile, select } from "../Helper";
import SmoothScrollbar from "smooth-scrollbar";

import HorizontalScrollPlugin from "./HorizontalScrollPlugin";
import SoftScrollPlugin from "./SoftScrollPlugin";
SmoothScrollbar.use(SoftScrollPlugin, HorizontalScrollPlugin);

var scroll;

function smooth() {
    const currentScrollContainer = document.querySelector(
        "[data-scroll-container]"
    );
    const hScroll = document.querySelector("[data-horizontal]");

    scroll = SmoothScrollbar.init(currentScrollContainer, {
        renderByPixels: true,
        damping: 0.075,
        plugins: {
            horizontalScroll: hScroll ? true : false,
        },
    });


    const topHeader = document.querySelector("header");
    topHeader.classList.remove("active");

    scroll.addListener((obj) => {
        const vProgress = (obj.offset.y / obj.limit.y) * 100;

        if (vProgress > 1) {
            topHeader.classList.add("active");
        } else {
            topHeader.classList.remove("active");
        }
    });




    /*
    const links = document.querySelectorAll("header a[href]");
    if (links) {
        links.forEach((element) => {
            element.addEventListener("click", () => {
                const href = element.getAttribute('href');
                const target = document.querySelector(href);
                if (target) {  scroll.scrollIntoView(target)  }
            });
        });
    }
    */



}

const cscroller = document.querySelector('.scroll-down');
if (cscroller) {
    cscroller.addEventListener('click', () => {
        scroll.scrollTo(0, 500, 1000);
    });
}

function scrollTop() {
    if (scroll && !isMobile()) {
        scroll.scrollTo(0, 0, 1000, {
            // callback: () => console.log('done!')
        });
    }
}
export { scroll, scrollTop, smooth };



















/*
import DisableScrollPlugin from "./disableScrollPlugin";
import  AnchorPlugin  from "./AnchorPlugin";


 scroll.addListener(({ offset }) => {
            if (!lastOffset) {
                lastOffset = offset;
                return;
            }

            const dir = [];

            if (offset.y < lastOffset.y) {
                dir[0] = 'up';
            } else if (offset.y > lastOffset.y) {
                dir[0] = 'down';
            } else {
                dir[0] = 'still';
            }

            lastOffset = offset;

            switch (dir[0]) {
                case 'up':
                    console.log("up")
                    break;
                case 'down':
                    console.log("down")
                    break;
                case 'still':
                    console.log("stoped")
                    break;
            }

        });



*/
